module.exports = __webpack_public_path__ + "img/cg.81fe440f.png";